export const DEFAULT_CHANNEL_NAME = 'MessengerIframeChannelDefault';
